import constants from '../constants';

const {
  tabIdentifiers,
  FIELD_NAMES_IN_GENERAL_TAB,
  FIELD_NAMES_IN_SEO_TAB,
  FIELD_NAMES_IN_OPEN_GRAPH_TAB,
  FIELD_NAMES_IN_CUSTOM_CODE_TAB,
} = constants;

const getFieldNamesByTabId = (tabId) => {
  switch (tabId) {
    case tabIdentifiers.GENERAL:
      return FIELD_NAMES_IN_GENERAL_TAB;
    case tabIdentifiers.SEO:
      return FIELD_NAMES_IN_SEO_TAB;
    case tabIdentifiers.OPEN_GRAPH:
      return FIELD_NAMES_IN_OPEN_GRAPH_TAB;
    case tabIdentifiers.CUSTOM_CODE:
      return FIELD_NAMES_IN_CUSTOM_CODE_TAB;
    default:
      return [];
  }
};

export default getFieldNamesByTabId;
